import React, { Component } from 'react';
import PropTypes from 'prop-types';
export default class Progress extends Component {
  render() {
    const { progress, color } = this.props;
    return (
      <div
        style={{
          transition: 'width .4s',
          width: progress + '%',
          background: color ? color : '#3ED6FF',
          height: 5,
          zIndex: 60,
          position: 'fixed',
          top: 0,
          left: 0,
          opacity: progress > 0 ? 1 : 0,
        }}
      >
      </div>
    );
  }
}

Progress.propTypes = {
  progress: PropTypes.number,
  color: PropTypes.string,
};



/** WEBPACK FOOTER **
 ** F:/agent-C107052-04/_work/420/s/Tube.Frontend/src/components/Progress.js
 **/